import { render, staticRenderFns } from "./CompanyClientAccess.vue?vue&type=template&id=7321cc66&"
import script from "./CompanyClientAccess.vue?vue&type=script&lang=js&"
export * from "./CompanyClientAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports